export default __webpack_public_path__ + "static/media/mobile.065974ce.svg";